module.exports = __webpack_public_path__ + "static/media/PIJL_00.71923b67.png";